import { render, staticRenderFns } from "./MightBeFixedInsight.vue?vue&type=template&id=87aa419a&scoped=true"
import script from "./MightBeFixedInsight.vue?vue&type=script&lang=js"
export * from "./MightBeFixedInsight.vue?vue&type=script&lang=js"
import style0 from "./MightBeFixedInsight.vue?vue&type=style&index=0&id=87aa419a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87aa419a",
  null
  
)

export default component.exports